'use client';

// ----------------------------------------------------------------------

export const themeOverrides = {
  components: {
    MuiFormControl: {
      defaultProps: { variant: 'filled' },
    },
    MuiTextField: {
      defaultProps: { variant: 'filled' },
    },
    MuiPickersTextField: {
      defaultProps: { variant: 'filled' },
    },
  },
};
